export const COUPON_STATUS = {
  0: '不可使用',
  1: '可使用'
}